module.exports = __webpack_public_path__ + "media/landing_1920x940-v4.d5356fef.mp4";